module.exports = __webpack_public_path__ + "img/img_actions.d47d563e.jpg";